import { Link } from "react-router-dom";
import { useWindowSize, replaceMenuName } from "../lib/Functions";
import { Caption, Detail, Grid, Image, InputText, Modal, Row } from "@maggioli-design-system/react";
import LoginButton from "./LoginButton";
import { IProdotto } from "../Interfaces/IProdotto";
import { ILoader } from "../Interfaces/ILoader";
import { useEffect } from "react";
import { MIN_LENGTH_SEARCH, searchbar } from "../lib/Constants";

interface ITopMenu {
    idProdotti: IProdotto[];
    setShowModal: Function;
    visible: boolean;
    setVisible: Function;
    ip: string;
    loader: ILoader;
    handler: {
        setMatch: Function;
        handlerText: {
            setSearchText: Function;
            searchText: string,
        };
    };
}

const TopMenu = ({ idProdotti, setShowModal, visible, setVisible, ip, handler, loader }: ITopMenu): JSX.Element => {
    const windowWidth = useWindowSize();

    useEffect(() => {
        loader.setLoader(idProdotti.length === 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idProdotti.length]);

    const onClickCategory = (cat: IProdotto) => {
        handler.handlerText.setSearchText("");
        handler.setMatch((prev: Object) => ({
            ...prev,
            url: `/categoria/${cat.descrizione.replaceAll(" ", "-").toLowerCase()}/${cat.id}/1`,
            params: {
                id: cat.id,
                slug: cat.descrizione.replaceAll(" ", "-").toLowerCase(),
            },
        }));
    };

    const sortFilterProducts = () => {
        return idProdotti
            .filter((a) => a.id.toString() !== "200" && a.id.toString() !== "201")
            .sort((a, b) => {
                const nameA = replaceMenuName(a);
                const nameB = replaceMenuName(b);
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });
    };

    const wideMenu = sortFilterProducts().map((v, i): JSX.Element => {
        const path = window.location.pathname.split("/");
        const style = "header-category-button py-2 px-3";
        const selectStyle = " bg-adjust-tone-16 rounded-xl";
        const currentAreaID = path[path.length - 2];
        const showSelectedStyle: boolean =v.id.toString() === currentAreaID;
        return (
            <Link
                key={i}
                to={`/categoria/${v.descrizione.replaceAll(" ", "-").toLowerCase()}/${v.id}/1`}
                onClick={() => onClickCategory(v)}
                aria-current={showSelectedStyle ? "page" : undefined}
            >
                <Caption className={showSelectedStyle ? style + selectStyle : style} htmlTag="div">
                    {replaceMenuName(v)}
                </Caption>
            </Link>
        );
    });

    const modalMenu = sortFilterProducts().map(
        (v, i): JSX.Element => (
            <Link key={i} to={`/categoria/${v.descrizione.replaceAll(" ", "-").toLowerCase()}/${v.id}/1`}>
                <Detail className="header-category-button py-2 px-3" htmlTag="div">
                    {replaceMenuName(v)}
                </Detail>
            </Link>
        ),
    );

    return windowWidth < 1024 ? (
        <Modal visible={visible} onCancel={() => setVisible(false)} position="left" footer={false} contentOnly>
            <Grid className="padding-normal pt-24">
                <Image alt="logo biblioteca digitale" className="modal-logo" src={`${process.env.PUBLIC_URL}/assets/images/logo-biblioteca-digitale.png`} />
                <Grid template="auto-fit" gutter="xsmall">
                    { searchbar({
                        text: handler.handlerText.searchText,
                        setText: handler.handlerText.setSearchText,
                        url: "",
                        placeholder: "Cerca nella biblioteca...",
                        id: "searchbar-menu",
                    }) }
                    {/* <InputText
                        onChange={(e: ChangeEvent<HTMLFormElement>) => handler.handlerText.setSearchText(e.target.value)}
                        className="overflow-visible"
                        icon="data-search"
                        placeholder="Cerca nella Biblioteca..."
                    /> */}
                    <LoginButton setShowModal={setShowModal} idProdotti={idProdotti} ip={ip} />
                </Grid>
            </Grid>
            <nav aria-label="Aree tematiche">
                <Grid gutter="none" className="padding-xsmall background-color-adjust-tone-19">
                    {modalMenu}
                </Grid>
            </nav>
        </Modal>
    ) : (
        <nav aria-label="Aree tematiche" className="p-5 background-color-adjust-tone-20 header-category-buttons fixed top-20 w-full z-10">
            <Row className="view-limit justify-center" gutter="none">
                {wideMenu}
            </Row>
        </nav>
    );
};

export default TopMenu;
